import {
  GenCurrency,
  GenDate,
  StepperStatusChip,
  WoIndicators,
  StatusButton,
} from '@pinnacleautomotive/clarity-components';
import GenServicesList from '../../components/GenServicesList';

export const UnapprovedColumns = (t, others) => [
  {
    field: 'date',
    headerName: t('tableHeaders.date'),
    valueGetter: data => <GenDate date={data.date} />,
  },
  {
    field: 'stock',
    headerName: t('tableHeaders.stock'),
    valueGetter: data => data.stockNumber,
  },
  {
    field: 'vin',
    headerName: t('tableHeaders.vin'),
    valueGetter: data => data.vehicle.vin,
  },
  {
    field: 'vendorName',
    headerName: t('tableHeaders.vendorName'),
    valueGetter: data => data.vendor.name,
  },
  {
    field: 'services',
    headerName: t('tableHeaders.services'),
    valueGetter: data => <GenServicesList services={data.services} />,
  },
  {
    field: 'price',
    headerName: t('tableHeaders.price'),
    valueGetter: data => <GenCurrency value={data.amount} />,
  },
  ...others,
];

export const CommonColumns = (
  t,
  mediumScreen,
  others,
  isDoneTab,
  isSortEnabled = false
) => [
  {
    field: 'stock',
    headerName: t('tableHeaders.stock'),
    valueGetter: data => data.stockNumber,
  },
  {
    field: 'date',
    headerName: isDoneTab ? t('tableHeaders.doneDate') : t('tableHeaders.date'),
    valueGetter: data => (
      <GenDate date={isDoneTab ? data.completedOn : data.date} />
    ),
  },
  {
    field: 'woNumber',
    headerName: t('tableHeaders.wo'),
    valueGetter: data => data.woNumber,
  },
  {
    field: 'vin',
    headerName: t('tableHeaders.vin'),
    valueGetter: data => data.vehicle.vin,
  },
  {
    field: 'vehicle',
    headerName: t('tableHeaders.vehicle'),
    valueGetter: data => `${data.vehicle.model} - ${data.vehicle.make}`,
  },
  {
    field: 'step',
    headerName: t('tableHeaders.step'),
    valueGetter: data => <StepperStatusChip step={data.step} />,
  },
  {
    field: 'services',
    headerName: t('tableHeaders.services'),
    valueGetter: data => <GenServicesList services={data.services} />,
  },
  {
    field: 'status',
    headerName: mediumScreen && t('tableHeaders.status'),
    valueGetter: data => <StatusButton status={data.status} />,
    isSortEnabled,
  },
  {
    field: 'request',
    valueGetter: data => (
      <WoIndicators
        specialRequests={data.specialRequests}
        promiseDate={data.promiseDate}
      />
    ),
  },
  ...others,
];
